/* eslint-disable quotes */
import { snakelize, camelize } from '../../../helpers/object'

export default ($axios: any) => ({
  // 찜하기 생성
  async modelRentalStatistics(data?: any) {
    return camelize(
      await $axios.post(`/statistics/model/rental`, snakelize(data)),
    )
  },

  async index(data?: any) {
    return camelize(await $axios.get(`/chart`, { params: snakelize(data) }))
  },
})
